import React, { useEffect, useMemo, useState } from 'react';
import supabase from '../../../../supabaseClient';

async function fetchCalendarEvents(dateISO, idConfig) {
  const { data, error } = await supabase
    .from('calendar_events')
    .select(`
      id, title, event_date, event_time, notes,
      category:calendar_categories ( id, name, color ),
      assigned_profile:profiles!calendar_events_assigned_to_fkey ( id, full_name )
    `)
    .eq('id_configuration', idConfig)
    .eq('event_date', dateISO)
    .order('event_time', { ascending: true });
  if (error) throw error;
  return data;
}

function CalendarDay({ currentDate, filterCategory, filterEmployee, onAddClick, onEventClick, eventsVersion, idConfig }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!idConfig) return;
    let cancelled = false;
    setLoading(true);
    fetchCalendarEvents(currentDate, idConfig)
      .then((data) => { if (!cancelled) setEvents(data); })
      .catch((err) => console.error('Błąd pobierania akcji kalendarza:', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [currentDate, eventsVersion, idConfig]);

  const filteredEvents = useMemo(() => events.filter((ev) =>
    (filterCategory === 'ALL' || ev.category?.id === filterCategory) &&
    (filterEmployee === 'ALL' || ev.assigned_profile?.id === filterEmployee)
  ), [events, filterCategory, filterEmployee]);

  return (
    <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 20, padding: 24 }}>
      {!loading && filteredEvents.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#705A5E', fontStyle: 'italic' }}>
          Brak zaplanowanych akcji tego dnia.
        </div>
      )}
    {filteredEvents.map((ev) => (
        <div
            key={ev.id}
            onClick={() => onEventClick?.(ev)}
            style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 16px', border: '1px solid #f0f0f0', borderRadius: 12, cursor: 'pointer' }}
        >
            <div style={{ width: 6, height: 36, borderRadius: 3, background: ev.category?.color || '#999' }} />
            <div style={{ minWidth: 64, fontSize: 13, fontWeight: 700, color: '#2C1419' }}>{ev.event_time?.slice(0, 5)}</div>
            <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#2C1419' }}>{ev.title}</div>
            <div style={{ fontSize: 12, color: '#705A5E' }}>{ev.category?.name} · {ev.assigned_profile?.full_name || '—'}</div>
            </div>
        </div>
        ))}
      <button onClick={() => onAddClick?.(currentDate)} style={{
        marginTop: 18, background: 'none', border: '1px dashed #e3d9d9', borderRadius: 8, padding: 10,
        fontSize: 12, color: '#705A5E', cursor: 'pointer', width: '100%',
      }}>
        + dodaj akcję na ten dzień
      </button>
      {loading && <div style={{ padding: 12, fontSize: 12, color: '#705A5E', textAlign: 'center' }}>Ładowanie…</div>}
    </div>
  );
}

export default CalendarDay;